

















import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import VS2 from "vue-script2";

Vue.use(VS2);

@Component
export default class ConsumerChatScript extends Vue {
    @Prop()
    name: string;
    @Prop()
    email: string;
    @Prop()
    phone: string;
    @Prop()
    hashkey: string;
    @Prop()
    campaignKey: string;
    @Prop()
    chatDelay: number;

  isChatHidden = true;
    mounted () {
      this.showChat();
    }
  showChat ()  {
    setTimeout(() => this.isChatHidden = false, this.chatDelay);
  }

}
